var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlreadyBought({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6978_40882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.929 31.2048C164.929 -22.9336 96.7601 14.6841 62.3834 13.1628C49.451 12.5904 19.4039 -10.0057 7.23859 5.32242C-8.41702 25.0482 39.0779 54.5532 38.5887 79.7319C38.1537 102.13 24.7809 123.884 39.7866 145.347C67.6818 185.247 122.288 171.878 122.288 126.112C122.288 67.8521 164.929 61.1268 164.929 31.2048Z",
    fill: "url(#paint0_linear_6978_40882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.94 35.5461L52.2281 24.9209",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2295 29.6965C54.8673 29.6965 57.0057 27.5581 57.0057 24.9203C57.0057 22.2824 54.8673 20.144 52.2295 20.144C49.5916 20.144 47.4532 22.2824 47.4532 24.9203C47.4532 27.5581 49.5916 29.6965 52.2295 29.6965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2295 29.6965C54.8673 29.6965 57.0057 27.5581 57.0057 24.9203C57.0057 22.2824 54.8673 20.144 52.2295 20.144C49.5916 20.144 47.4532 22.2824 47.4532 24.9203C47.4532 27.5581 49.5916 29.6965 52.2295 29.6965Z",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1365 44.4846L31.1825 27.9807",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1825 32.758C33.8203 32.758 35.9587 30.6196 35.9587 27.9818C35.9587 25.344 33.8203 23.2056 31.1825 23.2056C28.5446 23.2056 26.4062 25.344 26.4062 27.9818C26.4062 30.6196 28.5446 32.758 31.1825 32.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1825 32.758C33.8203 32.758 35.9587 30.6196 35.9587 27.9818C35.9587 25.344 33.8203 23.2056 31.1825 23.2056C28.5446 23.2056 26.4062 25.344 26.4062 27.9818C26.4062 30.6196 28.5446 32.758 31.1825 32.758Z",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M52.2295 37.6183C53.3178 37.6183 54.3176 37.2503 55.1207 36.6376L68.0548 44.8612C68.3294 45.0355 68.6357 45.119 68.9387 45.119C69.4843 45.119 70.0184 44.8486 70.3333 44.3539C70.8222 43.5848 70.5951 42.5648 69.826 42.0757L56.8962 33.8551C56.9668 33.5286 57.0061 33.1903 57.0061 32.8424C57.0061 30.2044 54.8678 28.0662 52.2298 28.0662C49.5919 28.0662 47.4536 30.2044 47.4536 32.8424C47.4533 35.4797 49.5919 37.6183 52.2295 37.6183Z",
    fill: "#2A282E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.096 69.6148L126.826 22.0126C126.025 20.3747 124.049 19.6961 122.411 20.4968L58.6142 51.6836C58.4852 51.4192 58.2884 51.1836 58.0221 51.0139L35.8494 36.9146C35.9197 36.5885 35.959 36.2508 35.959 35.9036C35.959 33.2659 33.8204 31.1273 31.1828 31.1273C28.5451 31.1273 26.4062 33.2656 26.4062 35.9036C26.4062 38.5416 28.5444 40.6798 31.1824 40.6798C32.2714 40.6798 33.2718 40.3111 34.0752 39.6978L55.397 53.2561L47.7382 57.0002C46.1003 57.8006 45.4217 59.7775 46.2224 61.4153L51.9866 73.2067H44.9738C41.3277 73.2067 38.3722 76.1622 38.3722 79.8083V95.7962C27.4344 95.7962 18.5675 104.663 18.5675 115.601C18.5675 126.539 27.4344 135.406 38.3722 135.406V150.16C38.3722 153.806 41.3277 156.761 44.9738 156.761H132.303C135.949 156.761 138.904 153.806 138.904 150.16V129.148C140.523 128.937 141.775 127.556 141.775 125.879V104.089C141.775 102.412 140.523 101.031 138.904 100.819V79.8079C138.904 79.4646 138.87 79.1303 138.819 78.8012L148.58 74.0299C150.218 73.2291 150.897 71.2523 150.096 69.6148Z",
    fill: "#2A282E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58 66.1081L73.9074 102.611C72.2696 103.412 70.2931 102.733 69.4923 101.095L46.2225 53.4935C45.422 51.8556 46.1007 49.8791 47.7382 49.0784L122.411 12.575C124.049 11.7746 126.026 12.4532 126.827 14.0907L150.096 61.6926C150.897 63.3305 150.218 65.3073 148.58 66.1081Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.882 18.2906L48.2782 57.6953L54.7966 71.029L135.4 31.6244L128.882 18.2906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.58 66.1081L73.9074 102.611C72.2696 103.412 70.2931 102.733 69.4923 101.095L46.2225 53.4935C45.422 51.8556 46.1007 49.8791 47.7382 49.0784L122.411 12.575C124.049 11.7746 126.026 12.4532 126.827 14.0907L150.096 61.6926C150.897 63.3305 150.218 65.3073 148.58 66.1081Z",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.396 43.4587L130.59 40.4309",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.629 55.587L133.684 46.7607",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9703 78.4972C76.2956 78.4972 72.8713 76.4696 71.0341 73.2061L62.3659 57.8089C60.5287 54.5451 60.5287 50.4904 62.3659 47.227L71.0345 31.8295C72.8713 28.566 76.2956 26.5383 79.9703 26.5383H97.3067C100.982 26.5383 104.406 28.566 106.243 31.8295L114.911 47.2266C116.748 50.4904 116.748 54.5451 114.911 57.8086L106.243 73.2061C104.406 76.4696 100.982 78.4972 97.3067 78.4972H79.9703Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9703 78.4972C76.2956 78.4972 72.8713 76.4696 71.0341 73.2061L62.3659 57.8089C60.5287 54.5451 60.5287 50.4904 62.3659 47.227L71.0345 31.8295C72.8713 28.566 76.2956 26.5383 79.9703 26.5383H97.3067C100.982 26.5383 104.406 28.566 106.243 31.8295L114.911 47.2266C116.748 50.4904 116.748 54.5451 114.911 57.8086L106.243 73.2061C104.406 76.4696 100.982 78.4972 97.3067 78.4972H79.9703Z",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9253 32.8015H79.3518C78.2319 32.8015 77.199 33.4052 76.6498 34.3813L67.296 50.9964C66.7643 51.9408 66.7643 53.0944 67.296 54.0387L76.6498 70.6539C77.199 71.6296 78.2319 72.2336 79.3518 72.2336H97.9253C99.0453 72.2336 100.078 71.6299 100.627 70.6539L109.981 54.0387C110.513 53.0944 110.513 51.9408 109.981 50.9964L100.627 34.3813C100.078 33.4052 99.0449 32.8015 97.9253 32.8015Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2584 39.762H87.0809V65.2734",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4573 65.2734L74.2761 52.5175L81.4573 55.4664V39.762",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0809 52.0747H90.5619",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2584 45.8538V65.2732",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6539 45.6765H99.8628L103.142 51.6618",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.303 148.839H44.9741C41.3281 148.839 38.3726 145.884 38.3726 142.238V71.886C38.3726 68.2399 41.3281 65.2844 44.9741 65.2844H132.303C135.949 65.2844 138.904 68.2399 138.904 71.886V142.238C138.904 145.884 135.949 148.839 132.303 148.839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.435 65.2844H44.9741C41.3281 65.2844 38.3726 68.2399 38.3726 71.886V94.2082",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3726 137.017V142.238C38.3726 145.884 41.3281 148.839 44.9741 148.839H132.303C135.949 148.839 138.904 145.884 138.904 142.238V71.886C138.904 68.2399 135.949 65.2844 132.303 65.2844H128.235",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2802 73.5364H52.2606",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.902 73.5364H124.853",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.57 23.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.674 73.5364H130.654V75.5168",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.654 81.6643V87.8117",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9.31 18.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.654 90.8853V92.8657",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.654 121.256V123.236",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.654 129.385V135.534",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "9.31 18.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.654 138.608V140.589H128.674",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.032 140.589H56.0813",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "11.57 23.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2606 140.589H50.2802",
    stroke: "#666666",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.475 121.257H116.685C111.216 121.257 106.783 116.824 106.783 111.355V102.769C106.783 97.2997 111.216 92.8665 116.685 92.8665H138.475C140.298 92.8665 141.776 94.3442 141.776 96.1672V117.957C141.776 119.78 140.298 121.257 138.475 121.257Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.475 121.257H116.685C111.216 121.257 106.783 116.824 106.783 111.355V102.769C106.783 97.2997 111.216 92.8665 116.685 92.8665H138.475C140.298 92.8665 141.776 94.3442 141.776 96.1672V117.957C141.776 119.78 140.298 121.257 138.475 121.257Z",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.182 111.188C120.461 111.188 122.308 109.34 122.308 107.062C122.308 104.783 120.461 102.936 118.182 102.936C115.904 102.936 114.057 104.783 114.057 107.062C114.057 109.34 115.904 111.188 118.182 111.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3726 127.483C49.3104 127.483 58.1772 118.617 58.1772 107.679C58.1772 96.7409 49.3104 87.874 38.3726 87.874C27.4347 87.874 18.5679 96.7409 18.5679 107.679C18.5679 118.617 27.4347 127.483 38.3726 127.483Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3726 122.532C46.5759 122.532 53.2261 115.882 53.2261 107.679C53.2261 99.4753 46.5759 92.8252 38.3726 92.8252C30.1692 92.8252 23.519 99.4753 23.519 107.679C23.519 115.882 30.1692 122.532 38.3726 122.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3726 127.483C49.3104 127.483 58.1772 118.617 58.1772 107.679C58.1772 96.7409 49.3104 87.874 38.3726 87.874C27.4347 87.874 18.5679 96.7409 18.5679 107.679C18.5679 118.617 27.4347 127.483 38.3726 127.483Z",
    stroke: "#2A282E",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9988 113.314H43.4958L42.1025 107.679H34.6424L33.2491 102.044H42.7462",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3726 113.314V115.931",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3726 99.4268V102.044",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2761 18.2942C76.0079 18.2942 77.4119 16.8903 77.4119 15.1584C77.4119 13.4266 76.0079 12.0227 74.2761 12.0227C72.5443 12.0227 71.1404 13.4266 71.1404 15.1584C71.1404 16.8903 72.5443 18.2942 74.2761 18.2942Z",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0044 76.408C26.7362 76.408 28.1401 75.004 28.1401 73.2722C28.1401 71.5404 26.7362 70.1365 25.0044 70.1365C23.2726 70.1365 21.8687 71.5404 21.8687 73.2722C21.8687 75.004 23.2726 76.408 25.0044 76.408Z",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4115 55.6L30.6157 51.8042L26.82 55.6L30.6157 59.3957L34.4115 55.6Z",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.023 83.1996L154.228 79.4038L150.432 83.1996L154.228 86.9953L158.023 83.1996Z",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.024 129.96L154.228 126.164L150.432 129.96L154.228 133.756L158.024 129.96Z",
    stroke: "#666666",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6978_40882",
    x1: 16.5621,
    y1: 123.52,
    x2: 144.482,
    y2: -4.39916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#676D80",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D6DB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6978_40882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 169,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlreadyBought);
export default __webpack_public_path__ + "static/media/already-bought.b1c75e5c5345847d50c55e2256d157c6.svg";
export { ForwardRef as ReactComponent };